import {
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { trackCustomEvent } from "../../utils/analytics";
import SerpJobLink from "./SerpJobLink";

export default function ExitIntentJobModal({
  data,
  tx,
  cpaModalTx,
  hostedApplyTx,
  numberOfJobsToCall,
}: {
  data: any;
  tx: any;
  numberOfJobsToCall: number;
  cpaModalTx: Queries.CpaModalFragment;
  hostedApplyTx: Queries.HostedApplyFragment;
}) {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  useEffect(() => {
    trackCustomEvent({
      category: "SERP",
      action: `Exit intent modal load`,
      label: window.location.pathname,
    });
  }, []);

  const job1 = data[numberOfJobsToCall + 1];
  const job2 = data[numberOfJobsToCall + 2];
  if (!job1 && !job2) return null;
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent pb="4" rounded="xl" mx="6" maxW={"50rem"}>
        <ModalHeader>
          <Heading size="md" pt="4">
            {tx.exitIntentTitlePlural}
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          display="flex"
          flexDirection="column"
          gap={{ base: "6", sm: "8" }}
        >
          {[job1, job2].map((job) => (
            <SerpJobLink
              cpaModalTx={cpaModalTx}
              hostedApplyTx={hostedApplyTx}
              key={job.id + job.url}
              job={job}
              tx={tx}
              onClick={() => {
                trackCustomEvent({
                  category: "SERP",
                  action: `Job click from exit intent modal`,
                  label: window.location.pathname,
                });
              }}
            />
          ))}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
